export default __webpack_public_path__ + "static/media/endcredit.91d73c1a.png";